import React, { useState, useEffect, useRef } from 'react';
 
import useTable from "../useTable";

import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import axios from 'axios';
import moment from 'moment';
import { DevolverOrdenPago } from './modalDevolverOrdenPago';

import { PrimaryButton } from '../../ui/buttons/Button';
import { Input } from '../../ui/inputs/Input';
const TablaDevolverOrdenPago = (props) => {
  var op = require('../../../src/modulos/datos')
  let token = localStorage.getItem('jwtToken');
  const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
  const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'N° CONTROL', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'FECHA', textAlign: 'center' },
    { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CÓDIGO', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
  ]
  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [aprob, setAprob] = useState(null);
  const [aprobaciones, setAprobaciones] = useState();
  const [aprodetalle, setAprodetalle] = useState();
  const txtBuscador = useRef()
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
  const {
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);
  const handleSearch = e => {
    let target = e.target;
    setFilterFn({
        fn: items => {
            if (target.value === "")
                return items;
            else
                return items.filter(x => {
                    if ((x.idaprobaciones !== null ? x.idaprobaciones.includes(target.value) : '')
                        || (x.ordenpagoaprob !== null ? x.ordenpagoaprob.toLowerCase().includes(target.value.toLowerCase()) : '')
                        || (x.observaciones !== null ? x.observaciones.toLowerCase().includes(target.value.toLowerCase()) : '')
                        || (x.fecha !== null ? moment.utc(x.fecha).format('DD-MM-YYYY').toLowerCase().includes(target.value.toLowerCase()) : '')

                    ) {
                        return x;
                    }
                });
        }
    })
}

  const seleccionarRegistros = () => {
    let endpoint = `${op.conexion}/api/administracion/registrosdevueltos?idefiscal=${idefiscal}`;
    setActivate(true);
    console.log(endpoint)
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status == 200) {
        console.log(response.data)
        setRecords(response.data);
      }
      setActivate(false)
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  }

  const seleccionarSolicitudesApro = (id) => {
    let campos = "*"
    let nomtab = "aprobaciones";
    let nomid = "idaprobaciones";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status == 200) {
        if (response.data.idaprobaciones > 0) {
          setAprobaciones(response.data);
          seleccionarSolicitudesAproDetalles(id);
        } else {
          setAprobaciones();
          seleccionarSolicitudesAproDetalles(id);
        }
      }
    }).catch((error) => {
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);
    })
  };

  const seleccionarSolicitudesAproDetalles = (id) => {
    let endpoint = `${op.conexion}/api/administracion/registrosordencompradetalles?id=${id}&idefiscal=${idefiscal}`;
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status == 200) {
        if (response.data.length > 0) {
          setAprodetalle(response.data);
          setMostrar2(true);
        } else {
          setAprodetalle();
          setMostrar2(true);
        }
      }
    }).catch((error) => {
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);
    })
  };
  const handleCloseSi = () => {
    setActivate(false);
  };
  const gestionar = (op, data) => (e) => {
    if (op === 4) {
      setOperacion(4);
      setAprob(data.aprobado);
      seleccionarSolicitudesApro(data.idaprobaciones);
    } else if (op === 1) {
      setOperacion(op);
      setMostrar2(true)
    } else if (op === 2) {
      setOperacion(op);
      setAprob(data.aprobado);
      seleccionarSolicitudesApro(data.idaprobaciones);
    }
  }
  useEffect(() => {
    seleccionarRegistros();
    setActivate(true);
  }, []);
  const handleCancelar = () => {
    setMostrar2(false);
  }
  const cerrar = () => {
    props.setTabla(0)
  }
  return (
    <div className='col-8 m-0 p-0 mt-5 mx-auto'>
      <div className='col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top text-light azulGradiant'>
        <h3 className='m-0'>Ordenes de Pago Devueltos</h3>
        <a type='button' onClick={cerrar}>
          salir<i className="fa fa-times ms-2"></i>
        </a>
      </div>
      <div className="col-12 m-0 p-2 d-flex justify-content-between">
        <div className="col-4 m-0 p-0">
          <input
            ref={txtBuscador}
            onChange={handleSearch}
            placeholder="Buscar"
            className='search-input form-control form-control-sm'
          />
        </div>
        <PrimaryButton
          onClick={gestionar(1, '')}
          icon="fa-plus m-0"
        ></PrimaryButton>
      </div>
      <div>
        <TblContainer>
          <TblHead />
          <tbody>
            {
              records && recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                  <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '30px' }}>{item.ordenpagodesaprob}</td>
                  <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '300px' }}>{item.observaciones}</td>
                  <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '50px' }}>{moment.utc(item.fecha).format('DD-MM-YYYY')}</td>
                  <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '30px' }}>{item.idaprobaciones}</td>
                  <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '100px' }}>
                    <button onClick={gestionar(4, item)} className="btn btn-sm mx-1 btn-info rounded-circle" ><i className="fas fa-eye"></i></button>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <DevolverOrdenPago
        show={mostrar2}
        operacion={operacion}
        aprobado={aprob}
        ubi={44}
        tip={0}
        aprobaciones={aprobaciones}
        aprodetalle={aprodetalle}
        titulo={operacion === 4 ? 'Orden Pago Devuelto' : /* operacion === 2 ? 'Imprimir Solicitud Aprobada' : */ 'Devolver Orden de Pago a Administración'}
        onHideCancelar={handleCancelar}
        onHideRenderizar={seleccionarRegistros}
      />
      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
      
<Dimmer active={activate} inverted>
      </Dimmer>

    </div>
  );
}
export default TablaDevolverOrdenPago;